import Helper from '@ember/component/helper';

export default class IsEqual extends Helper {
  compute(lhs, rhs) {
    return lhs === rhs;
  }
}
